import { Pill, PillProps } from '@nbirl/nbi-common-ui-libs';

import { StatusLabel } from './status-label.component';

type StatusPillProps = {
  enabled: boolean;
} & Omit<PillProps, 'variant'>;

export const StatusPill = ({ enabled, ...rest }: StatusPillProps) => (
  <Pill variant={enabled ? 'emerald' : 'red'} {...rest}>
    <StatusLabel enabled={enabled} />
  </Pill>
);
